import ContactDomain from "./contact-domain";

export default class ContactListDomain {
  contacts: ContactDomain[];

  // Exact total of the matched set. Only audience endpoints still send it;
  // the customers list endpoint sends hasMore instead and leaves this 0.
  totalCount: number;

  // Whether another page exists. Undefined when the endpoint predates the
  // Has-More header — callers then fall back to short-page detection.
  hasMore?: boolean;

  constructor(
    contacts: ContactDomain[],
    totalCount: number,
    hasMore?: boolean
  ) {
    this.contacts = contacts;
    this.totalCount = totalCount;
    this.hasMore = hasMore;
  }
}
